module.exports = __webpack_public_path__ + "static/img/ad10.3062e7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark40/ad10.png
// module id = qnPV
// module chunks = 12